module.exports = __webpack_public_path__ + "static/media/Shark Suit Guy.1d8a7e87.jpg";